













import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { useStore } from '~/composables/useStore';
import { getProductUnit } from '~/utils/modules/products';
import { ProductShowECResponseSchema } from '~/types/modules/product';
import { PromotionsName } from '~/enums/product';

export default defineComponent({
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const isDisabledToSetShippingOption = computed(() =>
      props.ecResponse.product_variants.some((variant) => variant.shipping_setting_not_allowed_flag)
    );

    const limitedStockCount = computed(() => {
      const { product_variants } = props.ecResponse;
      const limitedCount = product_variants.find((variant) => variant.sales_quantity_limit)?.sales_quantity_limit;
      if (product_variants.length > 1 || !limitedCount) {
        return;
      }
      return limitedCount + getProductUnit(props.ecResponse.categories);
    });

    const hasVISAPromotion = computed(() => {
      if (!store.state.auth.authenticated) return false;
      return (
        props.ecResponse.product_variants.some((variant) =>
          variant.price_settings.promotions.some(({ name }) => name === PromotionsName.VISA_HAPPY_WINE_PRICE)
        ) && store.getters['user/info/isVisaMember']
      );
    });

    return {
      isDisabledToSetShippingOption,
      limitedStockCount,
      hasVISAPromotion,
    };
  },
});
